// eslint-disable-next-line max-len
import {
  AspectRatio,
  ButtonGroup,
  Card,
  CardBody,
  Heading,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import Image from 'next/image';
import s from './ProductCard.module.css';
import cartContext from '../../../store/cart_context';
import {useContext} from 'react';

const ProductCard = ({
  clickHandler,
  product}) => {
  const cartCtx = useContext(cartContext);
  const price = product.hasVariants ?
    product.variants[0].price :
    product.price;
  return (
    <Card>
      {product.images?.length > 0 &&
           <AspectRatio
             ratio={4 / 3}
             position={'relative'}>
             <Image
               src={product.images[0]}
               alt={'image'}
               fill={true}
               className={s.image}/>
           </AspectRatio>}
      <Stack mt='6' spacing='3'>
        <CardBody>
          <VStack
            alignItems={'start'}>
            <Heading size={'md'}>{product.productName}</Heading>
            <Text color='blue.600' fontSize='2xl'>
              ${price / 100}
            </Text>
            <ButtonGroup spacing='2'>
              <button
                className={'custom__button'}
                onClick={() => clickHandler(product)}>
                Detail
              </button>
              {!product.hasVariants &&
                  <button
                    onClick={() => cartCtx.addCartItem(product)}
                    className={'custom__button'}>
                    Add to cart
                  </button>}
            </ButtonGroup>
          </VStack>
        </CardBody>
      </Stack>
    </Card>
  );
};

export default ProductCard;
